<div class="fullscreen-loading" *ngIf="visible">
    <div class="fullscreen-loading__overlay"></div>
    <div class="fullscreen-loading__content">
      <app-loading [visible]="true"></app-loading>
    </div>
</div>